import React from 'react';
import styled from 'styled-components';
import moment from 'moment';

const Card = styled.a`
  display: block;
  text-decoration: none;
  background: ${props => props.styles.backgroundColor || '#ffffff'};
  border-radius: ${props => props.styles.borderRadius || '8px'};
  padding: 16px;
  height: 100%;
  width: 100%;
  aspect-ratio: 3/4; // Maintains consistent card shape
`;

const ImageContainer = styled.div`
  width: 100%;
  aspect-ratio: 1/1; // Forces square aspect ratio
  border-radius: ${props => props.styles.borderRadius || '8px'};
  overflow: hidden;
  margin-bottom: 8px;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const Title = styled.p`
  font-size: ${props => props.styles.titleSize || '1.25rem'};
  font-weight: bold;
  color: ${props => props.styles.textColor || '#000000'};
  margin: 0px 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 3rem;
`;

const DateTime = styled.p`
  font-size: ${props => props.styles.fontSize || '0.875rem'};
  font-weight: bold;
  color: #444444;
  margin: 4px 0;
`;

const Location = styled.p`
  font-size: ${props => props.styles.fontSize || '0.875rem'};
  color: #444444;
  margin: 4px 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 2.5rem;
`;

const EventCard = ({ 
  image = "/api/placeholder/400/320",
  title, 
  location = "Location not specified", 
  date, 
  href,
  styles = {} 
}) => {
  return (
    <Card href={href} target="_blank" rel="noopener noreferrer" styles={styles}>
      <ImageContainer styles={styles}>
        <img src={image} alt={title} />
      </ImageContainer>
      <Title styles={styles}>{title}</Title>
      <DateTime styles={styles}>
        {moment(date).format("dddd, MMMM Do | h:mm A")}
      </DateTime>
      <Location styles={styles}>{location}</Location>
    </Card>
  );
};

export default EventCard;